module.exports = __webpack_public_path__ + "img/dialog-img-02.8e265254.png";